import { useTranslation } from 'react-i18next';

import { useMutation } from '@tanstack/react-query';

import { postResetPassword } from './api';

export const usePostResetPassword = () => {
  const { t } = useTranslation();

  const { mutate, isPending, isError, isSuccess, error } = useMutation({
    mutationFn: postResetPassword,
  });

  const getErrorMessage = () => {
    if (!isError) {
      return null;
    }

    return error instanceof Error
      ? error.message
      : t('auth resetPasswordError');
  };

  return {
    onResetPassword: mutate,
    isPending,
    error: getErrorMessage(),
    confirmationMessage: isSuccess ? t('auth passwordResetSuccess') : null,
  };
};
